import { memoize } from "lodash";
import { LanguageConfigs } from "../constants/LanguageConfigs";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingLanguageSettings = function () { return utilBalancing.getBalancing().LanguageSettings; };
export var selectLanguageInfo = memoize(function (langCode) {
    var language = selectRankingFilterLanguageSettings();
    return language.find(function (lang) { return lang.languageCode === langCode; });
});
export var selectLanguageIcon = memoize(function (langCode) {
    var lang = selectLanguageInfo(langCode);
    return lang ? lang.assetName : "";
});
export var selectRankingFilterLanguageSettings = memoize(function () {
    var LanguageSettings = selectBalancingLanguageSettings();
    var language = LanguageSettings[0].language;
    return language;
});
export var selectCoopLanguageSettings = memoize(function () {
    return selectRankingFilterLanguageSettings().filter(function (element) {
        return element.languageCode &&
            LanguageConfigs.CoopForbiddenLanguageCodes.indexOf(element.languageCode) < 0;
    });
});
export var balancingLanguageMemoizedFunctions = [
    selectBalancingLanguageSettings,
    selectLanguageInfo,
    selectLanguageIcon,
    selectRankingFilterLanguageSettings,
    selectCoopLanguageSettings,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingLanguage.ts
// module id = 233
// module chunks = 3